import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'
import DefaultLogo from '../../images/logo.png'
import { totalPrice } from "../../utils";
import { connect } from "react-redux";
import { removeFromCart } from "../../store/actions/action";


const Header = (props) => {
    const [cartActive, setcartState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    const { carts } = props;


    return (
        <header id="header" className={props.hclass}>
            <nav className="navigation navbar navbar-expand-lg navbar-light">
                <div className="container-fluid">
                    <div className="row align-items-center">
                        <div className="col-lg-3 col-md-3 col-3 d-lg-none dl-block">
                            <MobileMenu logoSrc={props.Logo || DefaultLogo} />
                        </div>
                        <div className="col-lg-8 col-md-6 col-6">
                            <div className="navbar-wrap">
                                <div className="navbar-header">
                                    <Link onClick={ClickHandler} className="navbar-brand d-none d-lg-inline-block" to="/home"><img src={props.Logo || DefaultLogo}
                                        alt="logo" /></Link>
                                </div>
                                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                                        <li>
                                            <Link onClick={ClickHandler} to="/home">Accueil</Link>
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} to="/about">À propos</Link>
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} to="/service">Services</Link>
                                        </li>
                                        <li>
                                            <Link onClick={ClickHandler} to="/project">Projets</Link>
                                        </li>
                                        {/* <li>
                                            <Link onClick={ClickHandler} to="/blog">Actualités</Link>
                                        </li> */}
                                        {/* <li>
                                            <Link onClick={ClickHandler} to="/shop">Boutique</Link>
                                        </li> */}
                                        <li>
                                            <Link onClick={ClickHandler} to="/contact">Contact</Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-3 col-3">
                            <div className="header-right">
                                <div className="get-btn">
                                    <Link onClick={ClickHandler} to="/contact" className="theme-btn" >Devis Gratuit</Link>
                                </div>
                    
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </header>
    )
}
const mapStateToProps = (state) => {
    return {
        carts: state.cartList.cart,
    };
};


export default connect(mapStateToProps, { removeFromCart })(Header);